import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the battery icon
 * 
 * @param {Object} props - The props of the component
 * @returns The battery icon
 */
const BatteryIcon = (props) => (
  <Icon viewBox="0 0 20 13.123" {...props}>
    <rect
      width="3.723"
      height="1.061"
      transform="translate(2.694 6.459)"
      fill="currentColor"
    />
    <path
      d="M176.915,66.736h-1.331V65.4h-1.061v1.331h-1.331V67.8h1.331v1.331h1.061V67.8h1.331Z"
      transform="translate(-159.614 -60.277)"
      fill="currentColor"
    />
    <path
      d="M1.411,2.921H18.589v8.791H1.411ZM13.983,0V1.51H5.963V0H2.694V1.51H0V13.123H20V1.51H17.253V0Z"
      fill="currentColor"
    />
  </Icon>
);

export default React.memo(BatteryIcon);
